/**
 * Returns if next button is disabled in steps page
 * @param purchasingFunds
 * @return {boolean}
 */
export function isFundListNextButtonDisabled(purchasingFunds) {
  return (
    purchasingFunds.length === 0 ||
    purchasingFunds.some(
      (fund) =>
        fund.currentYearError ||
        fund.priorYearError ||
        fund.combinedError ||
        fund.combinedDailyMaxError
    )
  );
}
